import {
    USER_CHANGE_PASSWORD_PENDING,
    USER_CHANGE_PASSWORD_SUCCESS,
    USER_CHANGE_PASSWORD_ERROR
} from "../../actions/master-data/user_change_password_action";

const initialState = {
    pending: false,
    error: null
};

export function userChangePassword(
    state = { ...initialState, userChangePassword: null },
    action
) {
    switch (action.type) {
        case USER_CHANGE_PASSWORD_PENDING:
            return {
                ...state,
                pending: true,
            };
        case USER_CHANGE_PASSWORD_SUCCESS:
            return {
                ...state,
                pending: false,
                userChangePassword: action.data,
            };
        case USER_CHANGE_PASSWORD_ERROR:
            return {
                ...state,
                pending: false,
                error: action.error,
            };
        default:
            return state;
    }
}

export const getUserChangePasswordPending = (state) => state.pending;
export const getUserChangePassword = (state) => state.userChangePassword;
export const getUserChangePasswordError = (state) => state.error;